import * as React from "react";
import { NavLink } from "react-router-dom";
import { GeneralAction } from "actions/general-action";

const TemplateSideBar = ({
  event,
  dispatch,
  t,
  event_id,
  templateModules,
  default_template_id,
  match,
}) => {
  return (
    <div className="app-side-application">
      <div className="btn-return-navigation">
        <NavLink
          to={`/event/edit/${event_id}`}
          onClick={() => {
            dispatch(GeneralAction.step(1));
          }}
        >
          <i className="material-symbols-outlined">arrow_back</i>
          {t("M_RETURN_TO_EDIT_EVENT")}
        </NavLink>
      </div>
      <ul className="sidebarTemplate">
        {templateModules && (
          <li
            className={`${
              window.location.pathname ===
                `/event/template/edit/${match.params.id}` ||
              window.location.pathname ===
                `/event/template/logs/${match.params.id}` ||
              window.location.pathname ===
                `/event/template/history/view/${match.params.template_id}/${match.params.id}`
                ? "bold activeList"
                : ""
            }`}
          >
            <span>
              <NavLink
                to={`/event/template/edit/${default_template_id}`}
              >
                {t("T_EMAIL_TEMPLATES")}
              </NavLink>
            </span>
            <ul>
              {templateModules.email &&
                templateModules.email.sub && (
                  <React.Fragment>
                    {Object.values(templateModules.email.sub).map((row) =>
                      Object.values(row.sub).map((row) => (
                        <li key={row.display}>
                          <span>
                            {" "}
                            <NavLink
                              isActive={(match, location) => {
                                if (
                                  location.pathname ===
                                    `/event/${row.url}` ||
                                  location.pathname ===
                                    `/event/template/logs/${row.id}` ||
                                  location.pathname ===
                                    `/event/template/history/view/${row.id}/${event_id}`
                                ) {
                                  return true;
                                }

                                return false;
                              }}
                              to={`/event/${row.url}`}
                            >
                              {t(`T_${row.alias}`)}
                            </NavLink>
                          </span>
                        </li>
                      ))
                    )}
                  </React.Fragment>
                )}
            </ul>
          </li>
        )}
      </ul>
    </div>
  );
};

export default TemplateSideBar; 